import { render, staticRenderFns } from "./TeacherLogin.vue?vue&type=template&id=059e08f7&scoped=true&"
import script from "./TeacherLogin.vue?vue&type=script&lang=js&"
export * from "./TeacherLogin.vue?vue&type=script&lang=js&"
import style0 from "./TeacherLogin.vue?vue&type=style&index=0&id=059e08f7&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059e08f7",
  null
  
)

export default component.exports